import React, {Component} from 'react';
import {connect} from 'react-redux';
import {adminLogout} from '../../../actions/login';
import {doPseudoLogout} from '../../../actions/users';

class AdminLogout extends Component {
  componentWillMount() {
    const {dispatch, profile} = this.props;
    if (profile.attributes['pseudo-login']) {
      dispatch(doPseudoLogout());
    } else {
      dispatch({type: 'CLEAR_PROFILE'});
      dispatch(adminLogout());
    }
  }

  redirectUrl = () => {
    const { profile } = this.props;

    if (profile.attributes['pseudo-login']) {
      const url = localStorage.getItem('admin-pseudo-login-started-from') || `/admin/users/${profile.id}/edit`;
      localStorage.removeItem('admin-pseudo-login-started-from');
      localStorage.removeItem('rep-pseudo-login-started-from');
      return url;
    }
    return '/admin/login';
  }

  render() {
    const { processed } = this.props;
    if (processed) {
      window.location.href = this.redirectUrl();
    }
    return (
      <p>
        Loggin out...
      </p>
    );
  }
}

export default connect(state => ({
  processed: state.logout.processed,
  profile: state.viewConfig.profile,
}))(AdminLogout);



// WEBPACK FOOTER //
// ./src/components/admin/logout/index.jsx